import { render, staticRenderFns } from "./CaptureImageDialog.vue?vue&type=template&id=1b34fbf8&scoped=true&"
import script from "./CaptureImageDialog.vue?vue&type=script&lang=js&"
export * from "./CaptureImageDialog.vue?vue&type=script&lang=js&"
import style0 from "./CaptureImageDialog.vue?vue&type=style&index=0&id=1b34fbf8&prod&lang=css&"
import style1 from "./CaptureImageDialog.vue?vue&type=style&index=1&id=1b34fbf8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b34fbf8",
  null
  
)

export default component.exports